import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getProjectQaWeldingInspectionsFailureReasons } from "../actions";

function mapStateToProps(state) {
  return {
    project_qa_welding_inspections_failure_reasons: state.project_qa_welding_inspections_failure_reasons,
  };
}

const ProjectQaWeldingInspectionsFailureReasonsIndex = (props) => {
  useEffect(() => {
    props.getProjectQaWeldingInspectionsFailureReasons();
  }, []);

  const { project_qa_welding_inspections_failure_reasons } = props;

  const readRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FailureReason", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FailureReason", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FailureReason", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Failure reasons</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/project/qa/welding_inspections/failure_reasons/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Failure reason</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={project_qa_welding_inspections_failure_reasons} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getProjectQaWeldingInspectionsFailureReasons })(ProjectQaWeldingInspectionsFailureReasonsIndex);
